export const showAsBusy = "GSvNo";
export default {showAsBusy};